"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.debugFieldsConfig = void 0;
exports.debugFieldsConfig = [
    {
        label: 'Author',
        fields: [
            {
                label: 'Mapper Email',
                searchKey: 'authorMapperEmail',
            },
            {
                label: 'Mapper Date',
                searchKey: 'authorMapperDate',
            },
            {
                label: 'Mapper Type',
                searchKey: 'authorMapperType',
            },
            {
                label: 'Mapper Comment',
                searchKey: 'authorMapperComment',
            },
            {
                label: 'Lot Mapper Email',
                searchKey: 'authorLotMapperEmail',
            },
            {
                label: 'Lot Mapper Date',
                searchKey: 'authorLotMapperDate',
            },
            {
                label: 'Lot Mapper Type',
                searchKey: 'authorLotMapperType',
            },
            {
                label: 'Lot Mapper Comment',
                searchKey: 'authorLotMapperComment',
            },
            {
                label: 'Lot Form',
                searchKey: 'lotForm',
            },
            {
                label: 'Lot Strength',
                searchKey: 'lotStrength',
            },
            {
                label: 'Lot Pack Form',
                searchKey: 'lotPackForm',
            },
            {
                label: 'Lot Pack Size',
                searchKey: 'lotPackSize',
            },
            {
                label: 'Debug Row Id',
                searchKey: 'debugRowId',
            },
        ],
    },
    {
        label: 'Debug',
        fields: [
            {
                label: 'Vam ID',
                searchKey: 'vamId',
            },
            {
                label: 'External ID',
                searchKey: 'externalId',
            },
            {
                label: 'Notice ID',
                searchKey: 'noticeId',
            },
            {
                label: 'Alternative Notice ID',
                searchKey: 'alternativeNoticeId',
            },
            {
                label: 'Notice URL',
                searchKey: 'noticeUrl',
            },
            {
                label: 'Source File Type',
                searchKey: 'debugSourceFileType',
            },
            {
                label: 'Entity S3 Bucket',
                searchKey: 'debugEntityS3Bucket',
            },
            {
                label: 'Entity S3 Key',
                searchKey: 'debugEntityS3Key',
            },
            {
                label: 'Filepath',
                searchKey: 'debugFilePath',
            },
            {
                label: 'Parsed Date',
                searchKey: 'debugParsedDate',
            },
            {
                label: 'Created Date',
                searchKey: 'debugCreatedDate',
            },
            {
                label: 'Last Update Date',
                searchKey: 'debugLastUpdatedDate',
            },
        ],
    },
];
//# sourceMappingURL=data:application/json;base64,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